/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export startSpin */
/* harmony export (immutable) */ __webpack_exports__["c"] = createLoader;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCerrar;
/* harmony export (immutable) */ __webpack_exports__["d"] = iniciarForms;
/* unused harmony export traerPolitica */
/* unused harmony export evaluarScrolls */
/* harmony export (immutable) */ __webpack_exports__["i"] = setDefaults;
/* harmony export (immutable) */ __webpack_exports__["g"] = ponerCaptchaModal;
/* unused harmony export afterSubmit */
/* unused harmony export obtenerTerminos */
/* unused harmony export obtenerCaptcha */
/* harmony export (immutable) */ __webpack_exports__["h"] = readURL;
/* harmony export (immutable) */ __webpack_exports__["b"] = addCommas;
/* unused harmony export getScript */
/* unused harmony export jSONInfo */
/* unused harmony export validateUser */
/* harmony export (immutable) */ __webpack_exports__["f"] = obtenerOffsetMenu;
/* unused harmony export espCalendar */
/* harmony export (immutable) */ __webpack_exports__["e"] = obtenerData;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function startSpin(show) {
  var $preload = $('body').find('.preload');

  if ($preload.length) {
    $preload.remove();
  }

  if (show) {
    $('body').append("<div class=\"preload\" style=\"position: fixed;left: 0;bottom: 0;right: 0;top: 0;background-color: rgba(0, 0, 0, 0.7);z-index: 2000;\">\n\t\t\t\t\t\t\t<div style=\"text-align: center; margin: 12rem auto\">\n\t\t\t\t\t\t\t\t<div class=\"preloader-wrapper big active\">\n\t\t\t\t\t\t\t\t\t<div class=\"spinner-layer spinner-white\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"circle-clipper left\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"circle\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"gap-patch\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"circle\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"circle-clipper right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"circle\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>");
  }
}
function createLoader(show) {
  if (show) {
    if ($('#cubre-page').length == 0) {
      $('body').append('<div id="cubre-page" style="position: fixed;top: 0;left: 0;bottom: 0;right: 0;background-color: rgba(0, 0, 0, .1);z-index: 99999;"></div>');
    }

    $('.capa, .progress').show();
  } else {
    $('.capa, .progress').hide();
    $('#cubre-page').remove();
  }
}
function addCerrar(modal) {
  if ($(modal).attr('data-close') === 'false') return;
  var instances = M.Modal.getInstance(modal),
      $close = $('<button class="btn btn-flat btn-close"><i class="material-icons">close</i></button>');
  $(modal).prepend($close);
  _dataForm = null;
  $close.css({
    position: 'absolute',
    right: '.375rem',
    top: '.375rem'
  });
  $close.on('click', function (event) {
    event.stopPropagation();
    event.preventDefault();
    instances.close();
    $close.remove();

    if (_dataForm !== null) {
      if (_dataForm.status.reload) {
        window.location.reload();
      }
    }
  });
}
function iniciarForms($forms) {
  $forms = $forms == undefined ? $('form:visible') : $forms;

  if ($().datetimepicker != undefined) {
    $.datetimepicker.setLocale('es');
    $forms.each(function () {
      var $dateTime = $(this).find('[data-tipo="date"], [data-tipo="datetime"]');
      $dateTime.each(function (index, element) {
        crearDateTime($(this));
      });
      var $timePicker = $(this).find('[data-tipo="time"]');
      $timePicker.datetimepicker({
        format: 'H:i',
        timepicker: true,
        datepicker: false
      });
    });
  }

  if ($().datetextentry != undefined) {
    $forms.find('.datetextentry').each(function () {
      $(this).datetextentry();
    });
  }

  if ($().chosen != undefined) {
    $forms.find('.chosen').each(function () {
      $(this).chosen({
        width: "100%",
        max_shown_results: 6
      });
    });
  }

  $forms.filter(':visible[data-captcha="true"]').each(function () {
    obtenerCaptcha($(this).attr('id'));
  });
  $forms.filter(':not(.excluir)').find('[data-send="true"]').on('click', function (event) {
    event.stopPropagation();
    event.preventDefault();
    var $este = $(this);
    if ($este.attr('data-disable') == 'true') return false;
    $este.parents('form').submit();
  });
  $forms.filter(':not(.excluir)').each(function (index, data) {
    var $form = $(this);
    $form.find('.politica[data-tdoc]:not(.custom)').each(function (index, data) {
      traerPolitica($(this), {}, $form.find('[data-send]'));
    });
  });
  $forms.filter(':not(.excluir)').each(function (index, data) {
    var $form = $(this),
        obj = {
      onfocusout: function onfocusout(element) {
        $(element).valid();
      },
      invalidHandler: function invalidHandler(event, validator) {
        console.log(event, validator);
        M.toast({
          html: 'Revisa los campos obligatorios'
        });
      },
      submitHandler: function submitHandler(form) {
        //console.log('submitHandler', form);		
        var $btn = $(form).find('[data-send]');
        $.ajax({
          url: $(form).attr('action'),
          type: 'POST',
          data: new FormData(form),
          processData: false,
          contentType: false,
          dataType: 'json',
          beforeSend: function beforeSend() {
            $btn.attr('data-disable', 'true');
            createLoader(true);
          },
          success: function success(data) {
            createLoader(false);
            _dataForm = data;
            afterSubmit(data, $(form), $btn);
          },
          error: function error(xhr, status) {
            console.log(xhr.responseText);
            M.toast({
              html: 'Ocurrió un error inesperado. Intenta nuevamente más tarde'
            });
            createLoader(false);
            $btn.attr('data-disable', 'false');
          }
        });
      },
      success: function success(label, element) {}
    };

    if ($form.attr('data-password') == 'true') {
      obj.rules = {
        password: {
          required: true,
          minlength: 6
        },
        password_confirm: {
          required: true,
          minlength: 5,
          equalTo: "#change_password"
        }
      };
    }

    $form.validate(obj);
  });
  M.updateTextFields();
}
function traerPolitica($politica) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $boton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  $politica.each(function () {
    var $esto = $(this),
        $info = $esto.find('.info'),
        $checkbox = $esto.find('.checkboxes [type="checkbox"].checkbox'),
        tdoc = $esto.data('tdoc'),
        changes = $esto.hasClass('changes');
    $esto.find('.boton-ver').remove();
    extraData.tipo = tdoc;
    obtenerTerminos(extraData, function (info) {
      if (info === false) {
        M.toast({
          html: 'Ocurrió un error inesperado. Intenta nuevamente más tarde'
        });
      } else {
        // console.log(info[ix].code)
        var ix = Object.keys(info)[0];
        $info.html('<div class="c-info" style="display:none">' + info[ix].documento + '</div>');
        $checkbox.val(info[ix].code);

        if (changes) {
          $esto.find('legend').text(info[ix].titulo);
        }

        setTimeout(function () {
          var width = $info.outerWidth();
          $info.css({
            width: width + 'px',
            'margin-bottom': '.75rem'
          });
          $info.find('.c-info').fadeIn('fast');
          $("<div class=\"center-align boton-ver\"><a href=\"".concat(_ULANG + _URI.ver, "/?code=").concat(info[ix].code, "\" target=\"_blank\" class=\"waves-effect waves-light btn-small verde-full\"><i class=\"material-icons left\">remove_red_eye</i>", 'Ver documento', "</a></div>")).insertBefore($esto.find('.checkboxes'));
          evaluarScrolls($info, $checkbox, $boton);
        }, 500);
      }
    });
  });
}
function evaluarScrolls($infoScroll, $checkbox) {
  var $boton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var porcentaje = ($infoScroll.scrollTop() + $infoScroll.innerHeight()) / $infoScroll[0].scrollHeight * 100;

  if (porcentaje >= 95) {
    $checkbox.prop('readonly', false);

    if ($boton != undefined) {
      checkTerms($checkbox, $boton);
    }

    return;
  }

  $checkbox.prop('readonly', true);
  $checkbox.attr('data-terms', 'true');

  if ($boton !== undefined) {
    $boton.prop('disabled', true).attr('data-disable', true);
  }

  $checkbox.prop('checked', false);
  $checkbox.off('click');
  $checkbox.on('click', function (event) {
    if ($(this).prop('readonly')) {
      M.toast({
        html: 'Antes de chequear esta casilla, debes leer el documento'
      });
      return false;
    }
  });
  $infoScroll.on('scroll', function (event) {
    var porcentaje = ($(this).scrollTop() + $(this).innerHeight()) / $(this)[0].scrollHeight * 100;

    if (porcentaje >= 95) {
      $checkbox.prop('readonly', false);

      if ($boton != undefined) {
        checkTerms($checkbox, $boton);
      }

      $(this).off('scroll');
    }
  });
}

function checkTerms($checkbox, $boton) {
  $checkbox.on('change', function (event) {
    var $form = $(this).parents('form'),
        $checkboxes = $form.find('[data-terms="true"]:not(:checked)');
    $boton.prop('disabled', $checkboxes.length != 0).attr('data-disable', $checkboxes.length != 0 ? 'true' : 'false');
  });
}

function setDefaults() {
  if ($.validator != undefined) {
    jQuery.extend(jQuery.validator.messages, {
      required: "Este campo es obligatorio.",
      remote: "Por favor, rellena este campo.",
      email: "Por favor, escribe una dirección de correo válida",
      url: "Por favor, escribe una URL válida.",
      date: "Por favor, escribe una fecha válida.",
      dateISO: "Por favor, escribe una fecha (ISO) válida.",
      number: "Por favor, escribe un número entero válido.",
      digits: "Por favor, escribe sólo dígitos.",
      creditcard: "Por favor, escribe un número de tarjeta válido.",
      equalTo: "Por favor, escribe el mismo valor de nuevo.",
      accept: "Por favor, escribe un valor con una extensión aceptada.",
      maxlength: jQuery.validator.format("Por favor, no escribas más de {0} caracteres."),
      minlength: jQuery.validator.format("Por favor, no escribas menos de {0} caracteres."),
      rangelength: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
      range: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1}."),
      max: jQuery.validator.format("Por favor, escribe un valor menor o igual a {0}."),
      min: jQuery.validator.format("Por favor, escribe un valor mayor o igual a {0}.")
    });
    $.validator.setDefaults({
      errorClass: 'invalid',
      validClass: "valid",
      errorPlacement: function errorPlacement(error, element) {
        var $form = element.closest("form") // ,	$label 	= $form.find("label[for='" + element.attr('id') + "']")
        ,
            isCheck = element.attr('type') == 'checkbox' || element.attr('type') == 'radio',
            $el = $form.find("label[for='" + element.attr('id') + "']");

        if (isCheck) {
          $el = element.parents('label').first();
        } else if (element.attr('type') == 'file') {
          $el = element.parents('.file-field').find('.file-path');
        } else if (element.hasClass('browser-default')) {
          $el = element;
        }

        if (error.text() == '') {
          $el.next('.helper-text').remove();
        } else {
          var $span = $el.next('.helper-text');

          if ($span.length == 0) {
            $('<span class="helper-text" data-error="' + error.text() + '">' + error.text() + '</span>').insertAfter($el);
          } else {
            //$span.attr('data-error', error.text())
            $span.text(error.text());
          }
        }
      }
    });
  }
}
function ponerCaptchaModal($modal) {
  $modal.find('form[data-captcha="true"]').each(function () {
    obtenerCaptcha($(this).attr('id'));
  });
}
function afterSubmit(data) {
  var $form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var $boton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  var status = data.status,
      callback = function callback(status) {
    if (status.go_to != '') {
      window.location.href = status.go_to;
      return true;
    }

    if (status.close) {
      var $modal = $form.parents('.modal');

      if ($modal.length != 0) {
        var instance = M.Modal.getInstance($modal.get(0));
        instance.close();
      }
    }

    if (status.reload) {
      window.location.reload();
      return true;
    }
  };

  if (status.reset && $form != undefined && !status.error) {
    $form.get(0).reset();
  }

  if (status.captcha) {
    obtenerCaptcha($form.attr('id'));
  }

  M.updateTextFields();

  if (_typeof(data.consola) === 'object') {
    console.log(data.consola);
  }

  if (status.localstorage) {
    for (var keys in status.localstorage) {
      window.localStorage.setItem(keys, JSON.stringify(status.localstorage[keys]));
    }
  }

  if (data.messages.length != 0) {
    afterSubmitToast(data.messages, function () {
      callback(status);
    });
  } else {
    callback(status);
  }

  if (typeof $boton !== 'undefined') {
    $boton.attr('data-disable', 'false');
  }

  if (status.functions.length != 0) {
    for (var k in status.functions) {
      if (typeof window[status.functions[k]] === 'function') {
        window[status.functions[k]](data);
      }
    }
  }
}

function afterSubmitToast(messages) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (messages.length == 0) {
    if (typeof callback === 'function') {
      callback();
    }
  } else {
    var messages_str = '<div>' + messages.join('<br />') + '</div>' + "<button class=\"btn-flat toast-action\" onClick='M.Toast.getInstance(this.parentElement).dismiss();'>Cerrar</button>";
    M.toast({
      html: messages_str,
      displayLength: 6000,
      completeCallback: callback
    });
  }
}

function obtenerTerminos(data, callback) {
  $.ajax({
    type: "POST",
    url: '/action/terminos/',
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      createLoader(true);
    },
    success: function success(data) {
      createLoader(false);

      if (data.ans.transaction == 'OK') {
        callback(data.ans.documents);
      } else {
        callback(false);
      }
    }
  });
}
function obtenerCaptcha(formId) {
  if (!_CAPTCHA) return false;
  var $form = $('#' + formId),
      $btn = $form.find('[data-send="true"]');
  $btn.addClass('disabled').attr('data-disable', 'true');
  grecaptcha.ready(function () {
    grecaptcha.execute(_CAPTCHA_WEBS, {
      action: $form.attr('action')
    }).then(function (token) {
      var $input = $form.find('[name="g-recaptcha-response"]');
      if ($input.length == 0) $input = $('<input type="hidden" name="g-recaptcha-response" />').appendTo($form);
      $input.val(token);
      $btn.removeClass('disabled').attr('data-disable', 'false');
    });
  });
}
function readURL(input, $img) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {
      $img.attr('src', e.target.result);
    };

    reader.readAsDataURL(input.files[0]);
  } else {
    $(input).parents('.file-field').find('.file-path').text('');
    $img.attr('src', $img.attr('data-src'));
  }
} // Mejorar números

function addCommas(nStr) {
  nStr += '';
  var x = nStr.split('.'),
      x1 = x[0],
      x2 = x.length > 1 ? ',' + x[1] : '',
      rgx = /(\d+)(\d{3})/;

  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + '.' + '$2');
  }

  return x1 + x2;
}
function getScript(url, success) {
  var script = document.createElement('script');
  script.src = url;
  var head = document.getElementsByTagName('head')[0],
      done = false;

  script.onload = script.onreadystatechange = function () {
    if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
      done = true;
      script.onload = script.onreadystatechange = null;
      head.removeChild(script);
      if (typeof success == 'function') success();
    }
  };

  try {
    head.appendChild(script);
  } catch (err) {
    console.log(err.message);
  }
}
function jSONInfo(config, option, callBack) {
  var cnfAjax = {
    url: config.action,
    type: config.type,
    data: option,
    dataType: "json",
    success: function success(data) {
      if (typeof callBack == 'function') callBack(data);
    },
    error: function error(jqXHR, textStatus, errorThrown) {
      console.log("jSONInfo - No se pudo cargar la pagina: ", jqXHR.responseText, errorThrown);
    }
  },
      $files = config.Files;
  $.ajax(cnfAjax).fail(function (jqXHR, textStatus, errorThrown) {
    console.log("jSONInfo - No se pudo cargar la pagina: ", jqXHR.responseText, errorThrown);
  });
}
function validateUser() {
  return validate;
}
function obtenerOffsetMenu(element) {
  if (element == undefined) return;
  var invisibleItems = [];

  for (var i = 0; i < element.childElementCount; i++) {
    if (element.children[i].offsetTop + element.children[i].offsetHeight > element.offsetTop + element.offsetHeight || element.children[i].offsetLeft + element.children[i].offsetWidth > element.offsetLeft + element.offsetWidth) {
      invisibleItems.push(element.children[i]);
    }
  }

  return invisibleItems;
}
function espCalendar() {
  return {
    cancel: 'Cerrar',
    clear: 'Limpiar',
    done: 'Aceptar',
    previousMonth: '‹',
    nextMonth: '›',
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'],
    weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb'],
    weekdaysAbbrev: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
}
function obtenerData(slugVista, keyVista, callback) {
  $.ajax({
    type: "POST",
    url: '/action/data-vista/',
    data: {
      slugVista: slugVista,
      keyVista: keyVista
    },
    dataType: 'json',
    beforeSend: function beforeSend() {
      createLoader(true);
    },
    success: function success(data) {
      createLoader(false);
      callback(data.ans);
    }
  });
}

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_utils_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_modals_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_chosen_v1_8_7_chosen_jquery_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_chosen_v1_8_7_chosen_jquery_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libs_chosen_v1_8_7_chosen_jquery_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_modernizr_modernizr_custom_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_modernizr_modernizr_custom_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__libs_modernizr_modernizr_custom_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_autocomplete_jquery_autocomplete_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_autocomplete_jquery_autocomplete_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__libs_autocomplete_jquery_autocomplete_js__);


 // modernizr

 // autocomplete


var $search_ac,
    heightHeader = 0;
$(document).ready(function () {
  Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["i" /* setDefaults */])();
  $('select').formSelect();
  $('.sidenav').sidenav();
  /* Pone la imagen seleccionada */

  $('[type="file"]').change(function (event) {
    var $imagen = $(this).parents('form').find('[data-id="' + $(this).attr('name') + '"]');
    Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["h" /* readURL */])(this, $imagen);
  });
  $('[href="/logout/"]').on('click', function (event) {
    event.stopPropagation();
    event.preventDefault();
    var config = {
      action: '/logout/',
      type: 'POST'
    };
    $.ajax({
      url: '/logout/',
      type: 'POST',
      success: function success(data) {
        window.location = '/';
      }
    });
  }); // AHORA REVISAMOS

  $('.modal:not(.propio)').modal({
    dismissible: false,
    onOpenStart: function onOpenStart(modal, trigger) {
      var $modal = $(modal),
          $trigger = $(trigger);
      Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["a" /* addCerrar */])(modal);
      Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["g" /* ponerCaptchaModal */])($modal);
      Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["d" /* iniciarForms */])($modal.find('form')); // Para traer productos de un carrito previo - perfil finaliza proceso

      switch (modal.id) {
        case 'prevlist':
          var code = trigger.dataset.code,
              $boton = $(modal).find('[data-send]');
          $boton.attr('data-disable', 'true');
          informacionListaAnterior(code, function (calculos) {
            ponerSoloItems($(modal).find('.items-lista'), calculos.carrito);
            $boton.attr('data-disable', 'false');
          });
          break;
      }
    },
    onOpenEnd: function onOpenEnd(modal, trigger) {
      var form = $(modal).find('form');
      M.updateTextFields();
    },
    onCloseEnd: function onCloseEnd(modal) {
      var $modal = $(modal);
    }
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["d" /* iniciarForms */])();
  /** Si el menú es muy extenso */
  //arreglarMenu()
  //$('.dropdown-trigger').dropdown({alignment: 'right', hover: !window.mobileAndTabletCheck(), coverTrigger: false, constrainWidth: false, container: $('body')});

  /** Restricciones de números */

  $("body").on("keydown", '[data-numbers="true"], [type="number"][min="1"], [type="number"][min="0"]', function (event) {
    var key = event.charCode || event.keyCode || 0; // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
    // home, end, period, and numpad decimal

    return key == 8 || key == 9 || key == 13 || key == 46 || key == 110 || key == 190 || key >= 35 && key <= 40 || key >= 48 && key <= 57 || key >= 96 && key <= 105;
  });
  /** Scroll */

  heightHeader = $('header.mainheader').outerHeight();
  $('.header-replace').css({
    'height': heightHeader + 'px',
    'display': 'none'
  });

  function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId = setTimeout(function () {
      method();
    }, delay);
  }

  $(window).scroll(function () {
    debounce(handleScroll, 180);
  });

  if (autoLogin) {
    var clogin = M.Modal.getInstance($('#clogin').get(0));
    clogin.options.opacity = .9;
    clogin.open();
  }
});

function handleScroll(data) {
  if (document.documentElement.scrollTop > heightHeader) {
    estadoHeader(true);
  } else {
    estadoHeader(false);
  }
}

function estadoHeader(fixed) {
  if (fixed) {
    if ($('header.mainheader').hasClass('floating')) return;
    $('.header-replace').css('display', 'block');
    $('header.mainheader').addClass('floating');
    $('header.mainheader').css({
      top: -heightHeader,
      opacity: 0.25
    }).animate({
      top: 0,
      opacity: 1
    }, 180, function () {});
  } else {
    if (!$('header.mainheader').hasClass('floating')) return;
    $('.header-replace').css('display', 'none');
    $('header.mainheader').removeClass('floating');
  }
}

function arreglarMenu() {
  var $menuOtros = $('<ul id="otro-menu" class="dropdown-content">'),
      $menu = $('#menu'),
      $_dots = $('<li class="tab dots"><a class="dropdown-trigger" href="#!"><i class="material-icons">more_vert</i></a></li>');
  $('body').append($menuOtros);
  $menu.prepend($_dots);
  var elementos = Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["f" /* obtenerOffsetMenu */])($menu.get(0));
  $_dots.remove();
  if (elementos == undefined) return;
  if (elementos.length == 0) return;

  for (var el in elementos) {
    var $_subMenu = $(elementos[el]).find('a').clone();
    $('<li />').append($_subMenu).appendTo($menuOtros);
    $(elementos[el]).remove();
  }

  $menu.append('<li class="tab"><a class="dropdown-trigger" href="#!" data-target="otro-menu"><i class="material-icons">more_vert</i></a></li>');
}

window.setTexto = function (ix) {
  return x_textos[ix] == undefined ? '' : x_textos[ix];
};

window.mobileAndTabletCheck = function () {
  var check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};

String.prototype.format = function () {
  var formatted = this;

  for (var i = 0; i < arguments.length; i++) {
    var regexp = new RegExp('\\{' + i + '\\}', 'gi');
    formatted = formatted.replace(regexp, arguments[i]);
  }

  return formatted;
};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export crearModals */
/* unused harmony export crearModalsDataHidden */
/* unused harmony export mandatoryModals */
/* unused harmony export crearGenModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_utils_js__ = __webpack_require__(1);

function crearModals($modals) {
  var optionsOpenStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var optionsOpenEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (optionsOpenStart === null) {
    optionsOpenStart = crearModalsDefaultOpenStart();
  }

  if (optionsOpenEnd === null) {
    optionsOpenEnd = crearModalsDefaultOpenEnd();
  }

  $modals.modal({
    dismissible: false,
    onOpenStart: optionsOpenStart,
    onOpenEnd: optionsOpenEnd
  });
}

function crearModalsDefaultOpenStart(modal, trigger) {
  return function (modal, trigger) {
    var $modal = $(modal);
    Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["a" /* addCerrar */])(modal);
    Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["g" /* ponerCaptchaModal */])($modal);

    if (trigger != undefined) {
      crearModalsDataHidden($modal, $(trigger));
    }
  };
}

function crearModalsDefaultOpenEnd(modal, trigger) {
  return function (modal, trigger) {
    var $modal = $(modal);

    if ($modal.find('form').length != 0) {
      Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["d" /* iniciarForms */])($modal.find('form'));
    }
  };
}

function crearModalsDataHidden($modal, $trigger) {
  var data = $trigger.data();

  for (var i in data) {
    $modal.find('[name="' + i + '"]').val(data[i]);
  }
}
function mandatoryModals() {
  var $mandatory = $('.mandatory').first();
  if ($mandatory.length == 0) return;
  $('body').css('overflow', 'hide');
  $mandatory.css('z-index', 9999);
  var instances = M.Modal.init($mandatory.get(0), {
    dismissible: false,
    opacity: .8
  });
  instances.open();
}
/** Crea un modal descargandolo de la nube */

function crearGenModal(trigger, id) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var option = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var optionsOpenStart = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var optionsOpenEnd = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var dismissible = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var autoOpen = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
  $('#' + id).remove();
  name = name === null ? id : name;
  option['dataset'] = $(trigger).data();
  $.ajax({
    url: '/modals/' + name + '/',
    type: 'POST',
    data: option,
    dataType: "html",
    beforeSend: function beforeSend() {
      Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["c" /* createLoader */])(true);
    },
    success: function success(data) {
      $('body').append(data);
      var $genModal = $('#' + id);
      crearModalsDataHidden($genModal, $(trigger));
      crearModals($genModal, optionsOpenStart, optionsOpenEnd);

      if (autoOpen) {
        var instances = M.Modal.getInstance($genModal.get(0));
        instances.open();
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["c" /* createLoader */])(false);
      if (typeof callBack == 'function') callBack(data);
    },
    error: function error(data, status, e) {
      console.log("jSONInfo - No se pudo cargar la pagina: ", data.responseText);
    }
  });
}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

/*!
Chosen, a Select Box Enhancer for jQuery and Prototype
by Patrick Filler for Harvest, http://getharvest.com

Version 1.8.7
Full source at https://github.com/harvesthq/chosen
Copyright (c) 2011-2018 Harvest http://getharvest.com

MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
This file is generated by `grunt build`, do not edit it by hand.
*/
(function () {
  var $,
      AbstractChosen,
      Chosen,
      SelectParser,
      bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
      extend = function extend(child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }

    function ctor() {
      this.constructor = child;
    }

    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
      hasProp = {}.hasOwnProperty;

  SelectParser = function () {
    function SelectParser() {
      this.options_index = 0;
      this.parsed = [];
    }

    SelectParser.prototype.add_node = function (child) {
      if (child.nodeName.toUpperCase() === "OPTGROUP") {
        return this.add_group(child);
      } else {
        return this.add_option(child);
      }
    };

    SelectParser.prototype.add_group = function (group) {
      var group_position, i, len, option, ref, results1;
      group_position = this.parsed.length;
      this.parsed.push({
        array_index: group_position,
        group: true,
        label: group.label,
        title: group.title ? group.title : void 0,
        children: 0,
        disabled: group.disabled,
        classes: group.className
      });
      ref = group.childNodes;
      results1 = [];

      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        results1.push(this.add_option(option, group_position, group.disabled));
      }

      return results1;
    };

    SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
      if (option.nodeName.toUpperCase() === "OPTION") {
        if (option.text !== "") {
          if (group_position != null) {
            this.parsed[group_position].children += 1;
          }

          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            value: option.value,
            text: option.text,
            html: option.innerHTML,
            title: option.title ? option.title : void 0,
            selected: option.selected,
            disabled: group_disabled === true ? group_disabled : option.disabled,
            group_array_index: group_position,
            group_label: group_position != null ? this.parsed[group_position].label : null,
            classes: option.className,
            style: option.style.cssText
          });
        } else {
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            empty: true
          });
        }

        return this.options_index += 1;
      }
    };

    return SelectParser;
  }();

  SelectParser.select_to_array = function (select) {
    var child, i, len, parser, ref;
    parser = new SelectParser();
    ref = select.childNodes;

    for (i = 0, len = ref.length; i < len; i++) {
      child = ref[i];
      parser.add_node(child);
    }

    return parser.parsed;
  };

  AbstractChosen = function () {
    function AbstractChosen(form_field, options1) {
      this.form_field = form_field;
      this.options = options1 != null ? options1 : {};
      this.label_click_handler = bind(this.label_click_handler, this);

      if (!AbstractChosen.browser_is_supported()) {
        return;
      }

      this.is_multiple = this.form_field.multiple;
      this.set_default_text();
      this.set_default_values();
      this.setup();
      this.set_up_html();
      this.register_observers();
      this.on_ready();
    }

    AbstractChosen.prototype.set_default_values = function () {
      this.click_test_action = function (_this) {
        return function (evt) {
          return _this.test_active_click(evt);
        };
      }(this);

      this.activate_action = function (_this) {
        return function (evt) {
          return _this.activate_field(evt);
        };
      }(this);

      this.active_field = false;
      this.mouse_on_container = false;
      this.results_showing = false;
      this.result_highlighted = null;
      this.is_rtl = this.options.rtl || /\bchosen-rtl\b/.test(this.form_field.className);
      this.allow_single_deselect = this.options.allow_single_deselect != null && this.form_field.options[0] != null && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
      this.disable_search_threshold = this.options.disable_search_threshold || 0;
      this.disable_search = this.options.disable_search || false;
      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
      this.group_search = this.options.group_search != null ? this.options.group_search : true;
      this.search_contains = this.options.search_contains || false;
      this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
      this.max_selected_options = this.options.max_selected_options || Infinity;
      this.inherit_select_classes = this.options.inherit_select_classes || false;
      this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
      this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
      this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
      this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
      this.case_sensitive_search = this.options.case_sensitive_search || false;
      return this.hide_results_on_select = this.options.hide_results_on_select != null ? this.options.hide_results_on_select : true;
    };

    AbstractChosen.prototype.set_default_text = function () {
      if (this.form_field.getAttribute("data-placeholder")) {
        this.default_text = this.form_field.getAttribute("data-placeholder");
      } else if (this.is_multiple) {
        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
      } else {
        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
      }

      this.default_text = this.escape_html(this.default_text);
      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
    };

    AbstractChosen.prototype.choice_label = function (item) {
      if (this.include_group_label_in_selected && item.group_label != null) {
        return "<b class='group-name'>" + this.escape_html(item.group_label) + "</b>" + item.html;
      } else {
        return item.html;
      }
    };

    AbstractChosen.prototype.mouse_enter = function () {
      return this.mouse_on_container = true;
    };

    AbstractChosen.prototype.mouse_leave = function () {
      return this.mouse_on_container = false;
    };

    AbstractChosen.prototype.input_focus = function (evt) {
      if (this.is_multiple) {
        if (!this.active_field) {
          return setTimeout(function (_this) {
            return function () {
              return _this.container_mousedown();
            };
          }(this), 50);
        }
      } else {
        if (!this.active_field) {
          return this.activate_field();
        }
      }
    };

    AbstractChosen.prototype.input_blur = function (evt) {
      if (!this.mouse_on_container) {
        this.active_field = false;
        return setTimeout(function (_this) {
          return function () {
            return _this.blur_test();
          };
        }(this), 100);
      }
    };

    AbstractChosen.prototype.label_click_handler = function (evt) {
      if (this.is_multiple) {
        return this.container_mousedown(evt);
      } else {
        return this.activate_field();
      }
    };

    AbstractChosen.prototype.results_option_build = function (options) {
      var content, data, data_content, i, len, ref, shown_results;
      content = '';
      shown_results = 0;
      ref = this.results_data;

      for (i = 0, len = ref.length; i < len; i++) {
        data = ref[i];
        data_content = '';

        if (data.group) {
          data_content = this.result_add_group(data);
        } else {
          data_content = this.result_add_option(data);
        }

        if (data_content !== '') {
          shown_results++;
          content += data_content;
        }

        if (options != null ? options.first : void 0) {
          if (data.selected && this.is_multiple) {
            this.choice_build(data);
          } else if (data.selected && !this.is_multiple) {
            this.single_set_selected_text(this.choice_label(data));
          }
        }

        if (shown_results >= this.max_shown_results) {
          break;
        }
      }

      return content;
    };

    AbstractChosen.prototype.result_add_option = function (option) {
      var classes, option_el;

      if (!option.search_match) {
        return '';
      }

      if (!this.include_option_in_results(option)) {
        return '';
      }

      classes = [];

      if (!option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("active-result");
      }

      if (option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("disabled-result");
      }

      if (option.selected) {
        classes.push("result-selected");
      }

      if (option.group_array_index != null) {
        classes.push("group-option");
      }

      if (option.classes !== "") {
        classes.push(option.classes);
      }

      option_el = document.createElement("li");
      option_el.className = classes.join(" ");

      if (option.style) {
        option_el.style.cssText = option.style;
      }

      option_el.setAttribute("data-option-array-index", option.array_index);
      option_el.innerHTML = option.highlighted_html || option.html;

      if (option.title) {
        option_el.title = option.title;
      }

      return this.outerHTML(option_el);
    };

    AbstractChosen.prototype.result_add_group = function (group) {
      var classes, group_el;

      if (!(group.search_match || group.group_match)) {
        return '';
      }

      if (!(group.active_options > 0)) {
        return '';
      }

      classes = [];
      classes.push("group-result");

      if (group.classes) {
        classes.push(group.classes);
      }

      group_el = document.createElement("li");
      group_el.className = classes.join(" ");
      group_el.innerHTML = group.highlighted_html || this.escape_html(group.label);

      if (group.title) {
        group_el.title = group.title;
      }

      return this.outerHTML(group_el);
    };

    AbstractChosen.prototype.results_update_field = function () {
      this.set_default_text();

      if (!this.is_multiple) {
        this.results_reset_cleanup();
      }

      this.result_clear_highlight();
      this.results_build();

      if (this.results_showing) {
        return this.winnow_results();
      }
    };

    AbstractChosen.prototype.reset_single_select_options = function () {
      var i, len, ref, result, results1;
      ref = this.results_data;
      results1 = [];

      for (i = 0, len = ref.length; i < len; i++) {
        result = ref[i];

        if (result.selected) {
          results1.push(result.selected = false);
        } else {
          results1.push(void 0);
        }
      }

      return results1;
    };

    AbstractChosen.prototype.results_toggle = function () {
      if (this.results_showing) {
        return this.results_hide();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.results_search = function (evt) {
      if (this.results_showing) {
        return this.winnow_results();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.winnow_results = function (options) {
      var escapedQuery, fix, i, len, option, prefix, query, ref, regex, results, results_group, search_match, startpos, suffix, text;
      this.no_results_clear();
      results = 0;
      query = this.get_search_text();
      escapedQuery = query.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      regex = this.get_search_regex(escapedQuery);
      ref = this.results_data;

      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        option.search_match = false;
        results_group = null;
        search_match = null;
        option.highlighted_html = '';

        if (this.include_option_in_results(option)) {
          if (option.group) {
            option.group_match = false;
            option.active_options = 0;
          }

          if (option.group_array_index != null && this.results_data[option.group_array_index]) {
            results_group = this.results_data[option.group_array_index];

            if (results_group.active_options === 0 && results_group.search_match) {
              results += 1;
            }

            results_group.active_options += 1;
          }

          text = option.group ? option.label : option.text;

          if (!(option.group && !this.group_search)) {
            search_match = this.search_string_match(text, regex);
            option.search_match = search_match != null;

            if (option.search_match && !option.group) {
              results += 1;
            }

            if (option.search_match) {
              if (query.length) {
                startpos = search_match.index;
                prefix = text.slice(0, startpos);
                fix = text.slice(startpos, startpos + query.length);
                suffix = text.slice(startpos + query.length);
                option.highlighted_html = this.escape_html(prefix) + "<em>" + this.escape_html(fix) + "</em>" + this.escape_html(suffix);
              }

              if (results_group != null) {
                results_group.group_match = true;
              }
            } else if (option.group_array_index != null && this.results_data[option.group_array_index].search_match) {
              option.search_match = true;
            }
          }
        }
      }

      this.result_clear_highlight();

      if (results < 1 && query.length) {
        this.update_results_content("");
        return this.no_results(query);
      } else {
        this.update_results_content(this.results_option_build());

        if (!(options != null ? options.skip_highlight : void 0)) {
          return this.winnow_results_set_highlight();
        }
      }
    };

    AbstractChosen.prototype.get_search_regex = function (escaped_search_string) {
      var regex_flag, regex_string;
      regex_string = this.search_contains ? escaped_search_string : "(^|\\s|\\b)" + escaped_search_string + "[^\\s]*";

      if (!(this.enable_split_word_search || this.search_contains)) {
        regex_string = "^" + regex_string;
      }

      regex_flag = this.case_sensitive_search ? "" : "i";
      return new RegExp(regex_string, regex_flag);
    };

    AbstractChosen.prototype.search_string_match = function (search_string, regex) {
      var match;
      match = regex.exec(search_string);

      if (!this.search_contains && (match != null ? match[1] : void 0)) {
        match.index += 1;
      }

      return match;
    };

    AbstractChosen.prototype.choices_count = function () {
      var i, len, option, ref;

      if (this.selected_option_count != null) {
        return this.selected_option_count;
      }

      this.selected_option_count = 0;
      ref = this.form_field.options;

      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];

        if (option.selected) {
          this.selected_option_count += 1;
        }
      }

      return this.selected_option_count;
    };

    AbstractChosen.prototype.choices_click = function (evt) {
      evt.preventDefault();
      this.activate_field();

      if (!(this.results_showing || this.is_disabled)) {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.keydown_checker = function (evt) {
      var ref, stroke;
      stroke = (ref = evt.which) != null ? ref : evt.keyCode;
      this.search_field_scale();

      if (stroke !== 8 && this.pending_backstroke) {
        this.clear_backstroke();
      }

      switch (stroke) {
        case 8:
          this.backstroke_length = this.get_search_field_value().length;
          break;

        case 9:
          if (this.results_showing && !this.is_multiple) {
            this.result_select(evt);
          }

          this.mouse_on_container = false;
          break;

        case 13:
          if (this.results_showing) {
            evt.preventDefault();
          }

          break;

        case 27:
          if (this.results_showing) {
            evt.preventDefault();
          }

          break;

        case 32:
          if (this.disable_search) {
            evt.preventDefault();
          }

          break;

        case 38:
          evt.preventDefault();
          this.keyup_arrow();
          break;

        case 40:
          evt.preventDefault();
          this.keydown_arrow();
          break;
      }
    };

    AbstractChosen.prototype.keyup_checker = function (evt) {
      var ref, stroke;
      stroke = (ref = evt.which) != null ? ref : evt.keyCode;
      this.search_field_scale();

      switch (stroke) {
        case 8:
          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
            this.keydown_backstroke();
          } else if (!this.pending_backstroke) {
            this.result_clear_highlight();
            this.results_search();
          }

          break;

        case 13:
          evt.preventDefault();

          if (this.results_showing) {
            this.result_select(evt);
          }

          break;

        case 27:
          if (this.results_showing) {
            this.results_hide();
          }

          break;

        case 9:
        case 16:
        case 17:
        case 18:
        case 38:
        case 40:
        case 91:
          break;

        default:
          this.results_search();
          break;
      }
    };

    AbstractChosen.prototype.clipboard_event_checker = function (evt) {
      if (this.is_disabled) {
        return;
      }

      return setTimeout(function (_this) {
        return function () {
          return _this.results_search();
        };
      }(this), 50);
    };

    AbstractChosen.prototype.container_width = function () {
      if (this.options.width != null) {
        return this.options.width;
      } else {
        return this.form_field.offsetWidth + "px";
      }
    };

    AbstractChosen.prototype.include_option_in_results = function (option) {
      if (this.is_multiple && !this.display_selected_options && option.selected) {
        return false;
      }

      if (!this.display_disabled_options && option.disabled) {
        return false;
      }

      if (option.empty) {
        return false;
      }

      return true;
    };

    AbstractChosen.prototype.search_results_touchstart = function (evt) {
      this.touch_started = true;
      return this.search_results_mouseover(evt);
    };

    AbstractChosen.prototype.search_results_touchmove = function (evt) {
      this.touch_started = false;
      return this.search_results_mouseout(evt);
    };

    AbstractChosen.prototype.search_results_touchend = function (evt) {
      if (this.touch_started) {
        return this.search_results_mouseup(evt);
      }
    };

    AbstractChosen.prototype.outerHTML = function (element) {
      var tmp;

      if (element.outerHTML) {
        return element.outerHTML;
      }

      tmp = document.createElement("div");
      tmp.appendChild(element);
      return tmp.innerHTML;
    };

    AbstractChosen.prototype.get_single_html = function () {
      return "<a class=\"chosen-single chosen-default\">\n  <span>" + this.default_text + "</span>\n  <div><b></b></div>\n</a>\n<div class=\"chosen-drop\">\n  <div class=\"chosen-search\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" />\n  </div>\n  <ul class=\"chosen-results\"></ul>\n</div>";
    };

    AbstractChosen.prototype.get_multi_html = function () {
      return "<ul class=\"chosen-choices\">\n  <li class=\"search-field\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" value=\"" + this.default_text + "\" />\n  </li>\n</ul>\n<div class=\"chosen-drop\">\n  <ul class=\"chosen-results\"></ul>\n</div>";
    };

    AbstractChosen.prototype.get_no_results_html = function (terms) {
      return "<li class=\"no-results\">\n  " + this.results_none_found + " <span>" + this.escape_html(terms) + "</span>\n</li>";
    };

    AbstractChosen.browser_is_supported = function () {
      if ("Microsoft Internet Explorer" === window.navigator.appName) {
        return document.documentMode >= 8;
      }

      if (/iP(od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
        return false;
      }

      return true;
    };

    AbstractChosen.default_multiple_text = "Select Some Options";
    AbstractChosen.default_single_text = "Select an Option";
    AbstractChosen.default_no_result_text = "No results match";
    return AbstractChosen;
  }();

  $ = jQuery;
  $.fn.extend({
    chosen: function chosen(options) {
      if (!AbstractChosen.browser_is_supported()) {
        return this;
      }

      return this.each(function (input_field) {
        var $this, chosen;
        $this = $(this);
        chosen = $this.data('chosen');

        if (options === 'destroy') {
          if (chosen instanceof Chosen) {
            chosen.destroy();
          }

          return;
        }

        if (!(chosen instanceof Chosen)) {
          $this.data('chosen', new Chosen(this, options));
        }
      });
    }
  });

  Chosen = function (superClass) {
    extend(Chosen, superClass);

    function Chosen() {
      return Chosen.__super__.constructor.apply(this, arguments);
    }

    Chosen.prototype.setup = function () {
      this.form_field_jq = $(this.form_field);
      return this.current_selectedIndex = this.form_field.selectedIndex;
    };

    Chosen.prototype.set_up_html = function () {
      var container_classes, container_props;
      container_classes = ["chosen-container"];
      container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));

      if (this.inherit_select_classes && this.form_field.className) {
        container_classes.push(this.form_field.className);
      }

      if (this.is_rtl) {
        container_classes.push("chosen-rtl");
      }

      container_props = {
        'class': container_classes.join(' '),
        'title': this.form_field.title
      };

      if (this.form_field.id.length) {
        container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
      }

      this.container = $("<div />", container_props);
      this.container.width(this.container_width());

      if (this.is_multiple) {
        this.container.html(this.get_multi_html());
      } else {
        this.container.html(this.get_single_html());
      }

      this.form_field_jq.hide().after(this.container);
      this.dropdown = this.container.find('div.chosen-drop').first();
      this.search_field = this.container.find('input').first();
      this.search_results = this.container.find('ul.chosen-results').first();
      this.search_field_scale();
      this.search_no_results = this.container.find('li.no-results').first();

      if (this.is_multiple) {
        this.search_choices = this.container.find('ul.chosen-choices').first();
        this.search_container = this.container.find('li.search-field').first();
      } else {
        this.search_container = this.container.find('div.chosen-search').first();
        this.selected_item = this.container.find('.chosen-single').first();
      }

      this.results_build();
      this.set_tab_index();
      return this.set_label_behavior();
    };

    Chosen.prototype.on_ready = function () {
      return this.form_field_jq.trigger("chosen:ready", {
        chosen: this
      });
    };

    Chosen.prototype.register_observers = function () {
      this.container.on('touchstart.chosen', function (_this) {
        return function (evt) {
          _this.container_mousedown(evt);
        };
      }(this));
      this.container.on('touchend.chosen', function (_this) {
        return function (evt) {
          _this.container_mouseup(evt);
        };
      }(this));
      this.container.on('mousedown.chosen', function (_this) {
        return function (evt) {
          _this.container_mousedown(evt);
        };
      }(this));
      this.container.on('mouseup.chosen', function (_this) {
        return function (evt) {
          _this.container_mouseup(evt);
        };
      }(this));
      this.container.on('mouseenter.chosen', function (_this) {
        return function (evt) {
          _this.mouse_enter(evt);
        };
      }(this));
      this.container.on('mouseleave.chosen', function (_this) {
        return function (evt) {
          _this.mouse_leave(evt);
        };
      }(this));
      this.search_results.on('mouseup.chosen', function (_this) {
        return function (evt) {
          _this.search_results_mouseup(evt);
        };
      }(this));
      this.search_results.on('mouseover.chosen', function (_this) {
        return function (evt) {
          _this.search_results_mouseover(evt);
        };
      }(this));
      this.search_results.on('mouseout.chosen', function (_this) {
        return function (evt) {
          _this.search_results_mouseout(evt);
        };
      }(this));
      this.search_results.on('mousewheel.chosen DOMMouseScroll.chosen', function (_this) {
        return function (evt) {
          _this.search_results_mousewheel(evt);
        };
      }(this));
      this.search_results.on('touchstart.chosen', function (_this) {
        return function (evt) {
          _this.search_results_touchstart(evt);
        };
      }(this));
      this.search_results.on('touchmove.chosen', function (_this) {
        return function (evt) {
          _this.search_results_touchmove(evt);
        };
      }(this));
      this.search_results.on('touchend.chosen', function (_this) {
        return function (evt) {
          _this.search_results_touchend(evt);
        };
      }(this));
      this.form_field_jq.on("chosen:updated.chosen", function (_this) {
        return function (evt) {
          _this.results_update_field(evt);
        };
      }(this));
      this.form_field_jq.on("chosen:activate.chosen", function (_this) {
        return function (evt) {
          _this.activate_field(evt);
        };
      }(this));
      this.form_field_jq.on("chosen:open.chosen", function (_this) {
        return function (evt) {
          _this.container_mousedown(evt);
        };
      }(this));
      this.form_field_jq.on("chosen:close.chosen", function (_this) {
        return function (evt) {
          _this.close_field(evt);
        };
      }(this));
      this.search_field.on('blur.chosen', function (_this) {
        return function (evt) {
          _this.input_blur(evt);
        };
      }(this));
      this.search_field.on('keyup.chosen', function (_this) {
        return function (evt) {
          _this.keyup_checker(evt);
        };
      }(this));
      this.search_field.on('keydown.chosen', function (_this) {
        return function (evt) {
          _this.keydown_checker(evt);
        };
      }(this));
      this.search_field.on('focus.chosen', function (_this) {
        return function (evt) {
          _this.input_focus(evt);
        };
      }(this));
      this.search_field.on('cut.chosen', function (_this) {
        return function (evt) {
          _this.clipboard_event_checker(evt);
        };
      }(this));
      this.search_field.on('paste.chosen', function (_this) {
        return function (evt) {
          _this.clipboard_event_checker(evt);
        };
      }(this));

      if (this.is_multiple) {
        return this.search_choices.on('click.chosen', function (_this) {
          return function (evt) {
            _this.choices_click(evt);
          };
        }(this));
      } else {
        return this.container.on('click.chosen', function (evt) {
          evt.preventDefault();
        });
      }
    };

    Chosen.prototype.destroy = function () {
      $(this.container[0].ownerDocument).off('click.chosen', this.click_test_action);

      if (this.form_field_label.length > 0) {
        this.form_field_label.off('click.chosen');
      }

      if (this.search_field[0].tabIndex) {
        this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
      }

      this.container.remove();
      this.form_field_jq.removeData('chosen');
      return this.form_field_jq.show();
    };

    Chosen.prototype.search_field_disabled = function () {
      this.is_disabled = this.form_field.disabled || this.form_field_jq.parents('fieldset').is(':disabled');
      this.container.toggleClass('chosen-disabled', this.is_disabled);
      this.search_field[0].disabled = this.is_disabled;

      if (!this.is_multiple) {
        this.selected_item.off('focus.chosen', this.activate_field);
      }

      if (this.is_disabled) {
        return this.close_field();
      } else if (!this.is_multiple) {
        return this.selected_item.on('focus.chosen', this.activate_field);
      }
    };

    Chosen.prototype.container_mousedown = function (evt) {
      var ref;

      if (this.is_disabled) {
        return;
      }

      if (evt && ((ref = evt.type) === 'mousedown' || ref === 'touchstart') && !this.results_showing) {
        evt.preventDefault();
      }

      if (!(evt != null && $(evt.target).hasClass("search-choice-close"))) {
        if (!this.active_field) {
          if (this.is_multiple) {
            this.search_field.val("");
          }

          $(this.container[0].ownerDocument).on('click.chosen', this.click_test_action);
          this.results_show();
        } else if (!this.is_multiple && evt && ($(evt.target)[0] === this.selected_item[0] || $(evt.target).parents("a.chosen-single").length)) {
          evt.preventDefault();
          this.results_toggle();
        }

        return this.activate_field();
      }
    };

    Chosen.prototype.container_mouseup = function (evt) {
      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
        return this.results_reset(evt);
      }
    };

    Chosen.prototype.search_results_mousewheel = function (evt) {
      var delta;

      if (evt.originalEvent) {
        delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
      }

      if (delta != null) {
        evt.preventDefault();

        if (evt.type === 'DOMMouseScroll') {
          delta = delta * 40;
        }

        return this.search_results.scrollTop(delta + this.search_results.scrollTop());
      }
    };

    Chosen.prototype.blur_test = function (evt) {
      if (!this.active_field && this.container.hasClass("chosen-container-active")) {
        return this.close_field();
      }
    };

    Chosen.prototype.close_field = function () {
      $(this.container[0].ownerDocument).off("click.chosen", this.click_test_action);
      this.active_field = false;
      this.results_hide();
      this.container.removeClass("chosen-container-active");
      this.clear_backstroke();
      this.show_search_field_default();
      this.search_field_scale();
      return this.search_field.blur();
    };

    Chosen.prototype.activate_field = function () {
      if (this.is_disabled) {
        return;
      }

      this.container.addClass("chosen-container-active");
      this.active_field = true;
      this.search_field.val(this.search_field.val());
      return this.search_field.focus();
    };

    Chosen.prototype.test_active_click = function (evt) {
      var active_container;
      active_container = $(evt.target).closest('.chosen-container');

      if (active_container.length && this.container[0] === active_container[0]) {
        return this.active_field = true;
      } else {
        return this.close_field();
      }
    };

    Chosen.prototype.results_build = function () {
      this.parsing = true;
      this.selected_option_count = null;
      this.results_data = SelectParser.select_to_array(this.form_field);

      if (this.is_multiple) {
        this.search_choices.find("li.search-choice").remove();
      } else {
        this.single_set_selected_text();

        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
          this.search_field[0].readOnly = true;
          this.container.addClass("chosen-container-single-nosearch");
        } else {
          this.search_field[0].readOnly = false;
          this.container.removeClass("chosen-container-single-nosearch");
        }
      }

      this.update_results_content(this.results_option_build({
        first: true
      }));
      this.search_field_disabled();
      this.show_search_field_default();
      this.search_field_scale();
      return this.parsing = false;
    };

    Chosen.prototype.result_do_highlight = function (el) {
      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;

      if (el.length) {
        this.result_clear_highlight();
        this.result_highlight = el;
        this.result_highlight.addClass("highlighted");
        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
        visible_top = this.search_results.scrollTop();
        visible_bottom = maxHeight + visible_top;
        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
        high_bottom = high_top + this.result_highlight.outerHeight();

        if (high_bottom >= visible_bottom) {
          return this.search_results.scrollTop(high_bottom - maxHeight > 0 ? high_bottom - maxHeight : 0);
        } else if (high_top < visible_top) {
          return this.search_results.scrollTop(high_top);
        }
      }
    };

    Chosen.prototype.result_clear_highlight = function () {
      if (this.result_highlight) {
        this.result_highlight.removeClass("highlighted");
      }

      return this.result_highlight = null;
    };

    Chosen.prototype.results_show = function () {
      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
        this.form_field_jq.trigger("chosen:maxselected", {
          chosen: this
        });
        return false;
      }

      this.container.addClass("chosen-with-drop");
      this.results_showing = true;
      this.search_field.focus();
      this.search_field.val(this.get_search_field_value());
      this.winnow_results();
      return this.form_field_jq.trigger("chosen:showing_dropdown", {
        chosen: this
      });
    };

    Chosen.prototype.update_results_content = function (content) {
      return this.search_results.html(content);
    };

    Chosen.prototype.results_hide = function () {
      if (this.results_showing) {
        this.result_clear_highlight();
        this.container.removeClass("chosen-with-drop");
        this.form_field_jq.trigger("chosen:hiding_dropdown", {
          chosen: this
        });
      }

      return this.results_showing = false;
    };

    Chosen.prototype.set_tab_index = function (el) {
      var ti;

      if (this.form_field.tabIndex) {
        ti = this.form_field.tabIndex;
        this.form_field.tabIndex = -1;
        return this.search_field[0].tabIndex = ti;
      }
    };

    Chosen.prototype.set_label_behavior = function () {
      this.form_field_label = this.form_field_jq.parents("label");

      if (!this.form_field_label.length && this.form_field.id.length) {
        this.form_field_label = $("label[for='" + this.form_field.id + "']");
      }

      if (this.form_field_label.length > 0) {
        return this.form_field_label.on('click.chosen', this.label_click_handler);
      }
    };

    Chosen.prototype.show_search_field_default = function () {
      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
        this.search_field.val(this.default_text);
        return this.search_field.addClass("default");
      } else {
        this.search_field.val("");
        return this.search_field.removeClass("default");
      }
    };

    Chosen.prototype.search_results_mouseup = function (evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();

      if (target.length) {
        this.result_highlight = target;
        this.result_select(evt);
        return this.search_field.focus();
      }
    };

    Chosen.prototype.search_results_mouseover = function (evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();

      if (target) {
        return this.result_do_highlight(target);
      }
    };

    Chosen.prototype.search_results_mouseout = function (evt) {
      if ($(evt.target).hasClass("active-result") || $(evt.target).parents('.active-result').first()) {
        return this.result_clear_highlight();
      }
    };

    Chosen.prototype.choice_build = function (item) {
      var choice, close_link;
      choice = $('<li />', {
        "class": "search-choice"
      }).html("<span>" + this.choice_label(item) + "</span>");

      if (item.disabled) {
        choice.addClass('search-choice-disabled');
      } else {
        close_link = $('<a />', {
          "class": 'search-choice-close',
          'data-option-array-index': item.array_index
        });
        close_link.on('click.chosen', function (_this) {
          return function (evt) {
            return _this.choice_destroy_link_click(evt);
          };
        }(this));
        choice.append(close_link);
      }

      return this.search_container.before(choice);
    };

    Chosen.prototype.choice_destroy_link_click = function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if (!this.is_disabled) {
        return this.choice_destroy($(evt.target));
      }
    };

    Chosen.prototype.choice_destroy = function (link) {
      if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
        if (this.active_field) {
          this.search_field.focus();
        } else {
          this.show_search_field_default();
        }

        if (this.is_multiple && this.choices_count() > 0 && this.get_search_field_value().length < 1) {
          this.results_hide();
        }

        link.parents('li').first().remove();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.results_reset = function () {
      this.reset_single_select_options();
      this.form_field.options[0].selected = true;
      this.single_set_selected_text();
      this.show_search_field_default();
      this.results_reset_cleanup();
      this.trigger_form_field_change();

      if (this.active_field) {
        return this.results_hide();
      }
    };

    Chosen.prototype.results_reset_cleanup = function () {
      this.current_selectedIndex = this.form_field.selectedIndex;
      return this.selected_item.find("abbr").remove();
    };

    Chosen.prototype.result_select = function (evt) {
      var high, item;

      if (this.result_highlight) {
        high = this.result_highlight;
        this.result_clear_highlight();

        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
          this.form_field_jq.trigger("chosen:maxselected", {
            chosen: this
          });
          return false;
        }

        if (this.is_multiple) {
          high.removeClass("active-result");
        } else {
          this.reset_single_select_options();
        }

        high.addClass("result-selected");
        item = this.results_data[high[0].getAttribute("data-option-array-index")];
        item.selected = true;
        this.form_field.options[item.options_index].selected = true;
        this.selected_option_count = null;

        if (this.is_multiple) {
          this.choice_build(item);
        } else {
          this.single_set_selected_text(this.choice_label(item));
        }

        if (this.is_multiple && (!this.hide_results_on_select || evt.metaKey || evt.ctrlKey)) {
          if (evt.metaKey || evt.ctrlKey) {
            this.winnow_results({
              skip_highlight: true
            });
          } else {
            this.search_field.val("");
            this.winnow_results();
          }
        } else {
          this.results_hide();
          this.show_search_field_default();
        }

        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
          this.trigger_form_field_change({
            selected: this.form_field.options[item.options_index].value
          });
        }

        this.current_selectedIndex = this.form_field.selectedIndex;
        evt.preventDefault();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.single_set_selected_text = function (text) {
      if (text == null) {
        text = this.default_text;
      }

      if (text === this.default_text) {
        this.selected_item.addClass("chosen-default");
      } else {
        this.single_deselect_control_build();
        this.selected_item.removeClass("chosen-default");
      }

      return this.selected_item.find("span").html(text);
    };

    Chosen.prototype.result_deselect = function (pos) {
      var result_data;
      result_data = this.results_data[pos];

      if (!this.form_field.options[result_data.options_index].disabled) {
        result_data.selected = false;
        this.form_field.options[result_data.options_index].selected = false;
        this.selected_option_count = null;
        this.result_clear_highlight();

        if (this.results_showing) {
          this.winnow_results();
        }

        this.trigger_form_field_change({
          deselected: this.form_field.options[result_data.options_index].value
        });
        this.search_field_scale();
        return true;
      } else {
        return false;
      }
    };

    Chosen.prototype.single_deselect_control_build = function () {
      if (!this.allow_single_deselect) {
        return;
      }

      if (!this.selected_item.find("abbr").length) {
        this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
      }

      return this.selected_item.addClass("chosen-single-with-deselect");
    };

    Chosen.prototype.get_search_field_value = function () {
      return this.search_field.val();
    };

    Chosen.prototype.get_search_text = function () {
      return $.trim(this.get_search_field_value());
    };

    Chosen.prototype.escape_html = function (text) {
      return $('<div/>').text(text).html();
    };

    Chosen.prototype.winnow_results_set_highlight = function () {
      var do_high, selected_results;
      selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
      do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();

      if (do_high != null) {
        return this.result_do_highlight(do_high);
      }
    };

    Chosen.prototype.no_results = function (terms) {
      var no_results_html;
      no_results_html = this.get_no_results_html(terms);
      this.search_results.append(no_results_html);
      return this.form_field_jq.trigger("chosen:no_results", {
        chosen: this
      });
    };

    Chosen.prototype.no_results_clear = function () {
      return this.search_results.find(".no-results").remove();
    };

    Chosen.prototype.keydown_arrow = function () {
      var next_sib;

      if (this.results_showing && this.result_highlight) {
        next_sib = this.result_highlight.nextAll("li.active-result").first();

        if (next_sib) {
          return this.result_do_highlight(next_sib);
        }
      } else {
        return this.results_show();
      }
    };

    Chosen.prototype.keyup_arrow = function () {
      var prev_sibs;

      if (!this.results_showing && !this.is_multiple) {
        return this.results_show();
      } else if (this.result_highlight) {
        prev_sibs = this.result_highlight.prevAll("li.active-result");

        if (prev_sibs.length) {
          return this.result_do_highlight(prev_sibs.first());
        } else {
          if (this.choices_count() > 0) {
            this.results_hide();
          }

          return this.result_clear_highlight();
        }
      }
    };

    Chosen.prototype.keydown_backstroke = function () {
      var next_available_destroy;

      if (this.pending_backstroke) {
        this.choice_destroy(this.pending_backstroke.find("a").first());
        return this.clear_backstroke();
      } else {
        next_available_destroy = this.search_container.siblings("li.search-choice").last();

        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
          this.pending_backstroke = next_available_destroy;

          if (this.single_backstroke_delete) {
            return this.keydown_backstroke();
          } else {
            return this.pending_backstroke.addClass("search-choice-focus");
          }
        }
      }
    };

    Chosen.prototype.clear_backstroke = function () {
      if (this.pending_backstroke) {
        this.pending_backstroke.removeClass("search-choice-focus");
      }

      return this.pending_backstroke = null;
    };

    Chosen.prototype.search_field_scale = function () {
      var div, i, len, style, style_block, styles, width;

      if (!this.is_multiple) {
        return;
      }

      style_block = {
        position: 'absolute',
        left: '-1000px',
        top: '-1000px',
        display: 'none',
        whiteSpace: 'pre'
      };
      styles = ['fontSize', 'fontStyle', 'fontWeight', 'fontFamily', 'lineHeight', 'textTransform', 'letterSpacing'];

      for (i = 0, len = styles.length; i < len; i++) {
        style = styles[i];
        style_block[style] = this.search_field.css(style);
      }

      div = $('<div />').css(style_block);
      div.text(this.get_search_field_value());
      $('body').append(div);
      width = div.width() + 25;
      div.remove();

      if (this.container.is(':visible')) {
        width = Math.min(this.container.outerWidth() - 10, width);
      }

      return this.search_field.width(width);
    };

    Chosen.prototype.trigger_form_field_change = function (extra) {
      this.form_field_jq.trigger("input", extra);
      return this.form_field_jq.trigger("change", extra);
    };

    return Chosen;
  }(AbstractChosen);
}).call(this);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-flexbox-flexboxlegacy-flexboxtweener-fontface-jpeg2000-jpegxr-json-localstorage-mediaqueries-srcset-webp-webpalpha-webplossless_webp_lossless-setclasses !*/
!function (e, A, n) {
  function t(e, A) {
    return _typeof(e) === A;
  }

  function r() {
    var e, A, n, r, o, s, a;

    for (var i in B) {
      if (B.hasOwnProperty(i)) {
        if (e = [], A = B[i], A.name && (e.push(A.name.toLowerCase()), A.options && A.options.aliases && A.options.aliases.length)) for (n = 0; n < A.options.aliases.length; n++) {
          e.push(A.options.aliases[n].toLowerCase());
        }

        for (r = t(A.fn, "function") ? A.fn() : A.fn, o = 0; o < e.length; o++) {
          s = e[o], a = s.split("."), 1 === a.length ? Modernizr[a[0]] = r : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = r), y.push((r ? "" : "no-") + a.join("-"));
        }
      }
    }
  }

  function o(e) {
    var A = Q.className,
        n = Modernizr._config.classPrefix || "";

    if (E && (A = A.baseVal), Modernizr._config.enableJSClass) {
      var t = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
      A = A.replace(t, "$1" + n + "js$2");
    }

    Modernizr._config.enableClasses && (A += " " + n + e.join(" " + n), E ? Q.className.baseVal = A : Q.className = A);
  }

  function s() {
    return "function" != typeof A.createElement ? A.createElement(arguments[0]) : E ? A.createElementNS.call(A, "http://www.w3.org/2000/svg", arguments[0]) : A.createElement.apply(A, arguments);
  }

  function a(e, A) {
    if ("object" == _typeof(e)) for (var n in e) {
      S(e, n) && a(n, e[n]);
    } else {
      e = e.toLowerCase();
      var t = e.split("."),
          r = Modernizr[t[0]];
      if (2 == t.length && (r = r[t[1]]), "undefined" != typeof r) return Modernizr;
      A = "function" == typeof A ? A() : A, 1 == t.length ? Modernizr[t[0]] = A : (!Modernizr[t[0]] || Modernizr[t[0]] instanceof Boolean || (Modernizr[t[0]] = new Boolean(Modernizr[t[0]])), Modernizr[t[0]][t[1]] = A), o([(A && 0 != A ? "" : "no-") + t.join("-")]), Modernizr._trigger(e, A);
    }
    return Modernizr;
  }

  function i() {
    var e = A.body;
    return e || (e = s(E ? "svg" : "body"), e.fake = !0), e;
  }

  function l(e, n, t, r) {
    var o,
        a,
        l,
        u,
        f = "modernizr",
        c = s("div"),
        d = i();
    if (parseInt(t, 10)) for (; t--;) {
      l = s("div"), l.id = r ? r[t] : f + (t + 1), c.appendChild(l);
    }
    return o = s("style"), o.type = "text/css", o.id = "s" + f, (d.fake ? d : c).appendChild(o), d.appendChild(c), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(A.createTextNode(e)), c.id = f, d.fake && (d.style.background = "", d.style.overflow = "hidden", u = Q.style.overflow, Q.style.overflow = "hidden", Q.appendChild(d)), a = n(c, e), d.fake ? (d.parentNode.removeChild(d), Q.style.overflow = u, Q.offsetHeight) : c.parentNode.removeChild(c), !!a;
  }

  function u(e, A) {
    return !!~("" + e).indexOf(A);
  }

  function f(e) {
    return e.replace(/([a-z])-([a-z])/g, function (e, A, n) {
      return A + n.toUpperCase();
    }).replace(/^-/, "");
  }

  function c(e, A) {
    return function () {
      return e.apply(A, arguments);
    };
  }

  function d(e, A, n) {
    var r;

    for (var o in e) {
      if (e[o] in A) return n === !1 ? e[o] : (r = A[e[o]], t(r, "function") ? c(r, n || A) : r);
    }

    return !1;
  }

  function p(e) {
    return e.replace(/([A-Z])/g, function (e, A) {
      return "-" + A.toLowerCase();
    }).replace(/^ms-/, "-ms-");
  }

  function g(A, n, t) {
    var r;

    if ("getComputedStyle" in e) {
      r = getComputedStyle.call(e, A, n);
      var o = e.console;
      if (null !== r) t && (r = r.getPropertyValue(t));else if (o) {
        var s = o.error ? "error" : "log";
        o[s].call(o, "getComputedStyle returning null, its possible modernizr test results are inaccurate");
      }
    } else r = !n && A.currentStyle && A.currentStyle[t];

    return r;
  }

  function m(A, t) {
    var r = A.length;

    if ("CSS" in e && "supports" in e.CSS) {
      for (; r--;) {
        if (e.CSS.supports(p(A[r]), t)) return !0;
      }

      return !1;
    }

    if ("CSSSupportsRule" in e) {
      for (var o = []; r--;) {
        o.push("(" + p(A[r]) + ":" + t + ")");
      }

      return o = o.join(" or "), l("@supports (" + o + ") { #modernizr { position: absolute; } }", function (e) {
        return "absolute" == g(e, null, "position");
      });
    }

    return n;
  }

  function h(e, A, r, o) {
    function a() {
      l && (delete k.style, delete k.modElem);
    }

    if (o = t(o, "undefined") ? !1 : o, !t(r, "undefined")) {
      var i = m(e, r);
      if (!t(i, "undefined")) return i;
    }

    for (var l, c, d, p, g, h = ["modernizr", "tspan", "samp"]; !k.style && h.length;) {
      l = !0, k.modElem = s(h.shift()), k.style = k.modElem.style;
    }

    for (d = e.length, c = 0; d > c; c++) {
      if (p = e[c], g = k.style[p], u(p, "-") && (p = f(p)), k.style[p] !== n) {
        if (o || t(r, "undefined")) return a(), "pfx" == A ? p : !0;

        try {
          k.style[p] = r;
        } catch (w) {}

        if (k.style[p] != g) return a(), "pfx" == A ? p : !0;
      }
    }

    return a(), !1;
  }

  function w(e, A, n, r, o) {
    var s = e.charAt(0).toUpperCase() + e.slice(1),
        a = (e + " " + C.join(s + " ") + s).split(" ");
    return t(A, "string") || t(A, "undefined") ? h(a, A, r, o) : (a = (e + " " + T.join(s + " ") + s).split(" "), d(a, A, n));
  }

  function v(e, A, t) {
    return w(e, n, n, A, t);
  }

  var y = [],
      B = [],
      b = {
    _version: "3.6.0",
    _config: {
      classPrefix: "",
      enableClasses: !0,
      enableJSClass: !0,
      usePrefixes: !0
    },
    _q: [],
    on: function on(e, A) {
      var n = this;
      setTimeout(function () {
        A(n[e]);
      }, 0);
    },
    addTest: function addTest(e, A, n) {
      B.push({
        name: e,
        fn: A,
        options: n
      });
    },
    addAsyncTest: function addAsyncTest(e) {
      B.push({
        name: null,
        fn: e
      });
    }
  },
      Modernizr = function Modernizr() {};

  Modernizr.prototype = b, Modernizr = new Modernizr(), Modernizr.addTest("json", "JSON" in e && "parse" in JSON && "stringify" in JSON);
  var Q = A.documentElement,
      E = "svg" === Q.nodeName.toLowerCase();
  Modernizr.addTest("srcset", "srcset" in s("img"));
  var S;
  !function () {
    var e = {}.hasOwnProperty;
    S = t(e, "undefined") || t(e.call, "undefined") ? function (e, A) {
      return A in e && t(e.constructor.prototype[A], "undefined");
    } : function (A, n) {
      return e.call(A, n);
    };
  }(), b._l = {}, b.on = function (e, A) {
    this._l[e] || (this._l[e] = []), this._l[e].push(A), Modernizr.hasOwnProperty(e) && setTimeout(function () {
      Modernizr._trigger(e, Modernizr[e]);
    }, 0);
  }, b._trigger = function (e, A) {
    if (this._l[e]) {
      var n = this._l[e];
      setTimeout(function () {
        var e, t;

        for (e = 0; e < n.length; e++) {
          (t = n[e])(A);
        }
      }, 0), delete this._l[e];
    }
  }, Modernizr._q.push(function () {
    b.addTest = a;
  }), Modernizr.addAsyncTest(function () {
    var e = new Image();
    e.onload = e.onerror = function () {
      a("jpeg2000", 1 == e.width);
    }, e.src = "data:image/jp2;base64,/0//UQAyAAAAAAABAAAAAgAAAAAAAAAAAAAABAAAAAQAAAAAAAAAAAAEBwEBBwEBBwEBBwEB/1IADAAAAAEAAAQEAAH/XAAEQED/ZAAlAAFDcmVhdGVkIGJ5IE9wZW5KUEVHIHZlcnNpb24gMi4wLjD/kAAKAAAAAABYAAH/UwAJAQAABAQAAf9dAAUBQED/UwAJAgAABAQAAf9dAAUCQED/UwAJAwAABAQAAf9dAAUDQED/k8+kEAGvz6QQAa/PpBABr994EAk//9k=";
  }), Modernizr.addAsyncTest(function () {
    var e = new Image();
    e.onload = e.onerror = function () {
      a("jpegxr", 1 == e.width, {
        aliases: ["jpeg-xr"]
      });
    }, e.src = "data:image/vnd.ms-photo;base64,SUm8AQgAAAAFAAG8AQAQAAAASgAAAIC8BAABAAAAAQAAAIG8BAABAAAAAQAAAMC8BAABAAAAWgAAAMG8BAABAAAAHwAAAAAAAAAkw91vA07+S7GFPXd2jckNV01QSE9UTwAZAYBxAAAAABP/gAAEb/8AAQAAAQAAAA==";
  }), Modernizr.addAsyncTest(function () {
    var e = new Image();
    e.onerror = function () {
      a("webpalpha", !1, {
        aliases: ["webp-alpha"]
      });
    }, e.onload = function () {
      a("webpalpha", 1 == e.width, {
        aliases: ["webp-alpha"]
      });
    }, e.src = "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==";
  }), Modernizr.addAsyncTest(function () {
    var e = new Image();
    e.onerror = function () {
      a("webplossless", !1, {
        aliases: ["webp-lossless"]
      });
    }, e.onload = function () {
      a("webplossless", 1 == e.width, {
        aliases: ["webp-lossless"]
      });
    }, e.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
  }), Modernizr.addAsyncTest(function () {
    function e(e, A, n) {
      function t(A) {
        var t = A && "load" === A.type ? 1 == r.width : !1,
            o = "webp" === e;
        a(e, o && t ? new Boolean(t) : t), n && n(A);
      }

      var r = new Image();
      r.onerror = t, r.onload = t, r.src = A;
    }

    var A = [{
      uri: "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",
      name: "webp"
    }, {
      uri: "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",
      name: "webp.alpha"
    }, {
      uri: "data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",
      name: "webp.animation"
    }, {
      uri: "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",
      name: "webp.lossless"
    }],
        n = A.shift();
    e(n.name, n.uri, function (n) {
      if (n && "load" === n.type) for (var t = 0; t < A.length; t++) {
        e(A[t].name, A[t].uri);
      }
    });
  });
  var x = "Moz O ms Webkit",
      C = b._config.usePrefixes ? x.split(" ") : [];
  b._cssomPrefixes = C;
  var T = b._config.usePrefixes ? x.toLowerCase().split(" ") : [];
  b._domPrefixes = T;

  var U = b.testStyles = l,
      _ = function () {
    var e = navigator.userAgent,
        A = e.match(/w(eb)?osbrowser/gi),
        n = e.match(/windows phone/gi) && e.match(/iemobile\/([0-9])+/gi) && parseFloat(RegExp.$1) >= 9;
    return A || n;
  }();

  _ ? Modernizr.addTest("fontface", !1) : U('@font-face {font-family:"font";src:url("https://")}', function (e, n) {
    var t = A.getElementById("smodernizr"),
        r = t.sheet || t.styleSheet,
        o = r ? r.cssRules && r.cssRules[0] ? r.cssRules[0].cssText : r.cssText || "" : "",
        s = /src/i.test(o) && 0 === o.indexOf(n.split(" ")[0]);
    Modernizr.addTest("fontface", s);
  });

  var D = function () {
    var A = e.matchMedia || e.msMatchMedia;
    return A ? function (e) {
      var n = A(e);
      return n && n.matches || !1;
    } : function (A) {
      var n = !1;
      return l("@media " + A + " { #modernizr { position: absolute; } }", function (A) {
        n = "absolute" == (e.getComputedStyle ? e.getComputedStyle(A, null) : A.currentStyle).position;
      }), n;
    };
  }();

  b.mq = D, Modernizr.addTest("mediaqueries", D("only all"));
  var R = {
    elem: s("modernizr")
  };

  Modernizr._q.push(function () {
    delete R.elem;
  });

  var k = {
    style: R.elem.style
  };
  Modernizr._q.unshift(function () {
    delete k.style;
  }), b.testAllProps = w, b.testAllProps = v, Modernizr.addTest("flexboxlegacy", v("boxDirection", "reverse", !0)), Modernizr.addTest("flexbox", v("flexBasis", "1px", !0)), Modernizr.addTest("flexboxtweener", v("flexAlign", "end", !0)), Modernizr.addTest("localstorage", function () {
    var e = "modernizr";

    try {
      return localStorage.setItem(e, e), localStorage.removeItem(e), !0;
    } catch (A) {
      return !1;
    }
  }), r(), o(y), delete b.addTest, delete b.addAsyncTest;

  for (var J = 0; J < Modernizr._q.length; J++) {
    Modernizr._q[J]();
  }

  e.Modernizr = Modernizr;
}(window, document);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
*  Ajax Autocomplete for jQuery, version 1.4.11
*  (c) 2017 Tomas Kirda
*
*  Ajax Autocomplete for jQuery is freely distributable under the terms of an MIT-style license.
*  For details, see the web site: https://github.com/devbridge/jQuery-Autocomplete
*/

/*jslint  browser: true, white: true, single: true, this: true, multivar: true */

/*global define, window, document, jQuery, exports, require */
// Expose plugin as an AMD module if AMD loader is present:
(function (factory) {
  "use strict";

  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(15)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof require === 'function') {
    // Browserify
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
})(function ($) {
  'use strict';

  var utils = function () {
    return {
      escapeRegExChars: function escapeRegExChars(value) {
        return value.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
      },
      createNode: function createNode(containerClass) {
        var div = document.createElement('div');
        div.className = containerClass;
        div.style.position = 'absolute';
        div.style.display = 'none';
        return div;
      }
    };
  }(),
      keys = {
    ESC: 27,
    TAB: 9,
    RETURN: 13,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
  },
      noop = $.noop;

  function Autocomplete(el, options) {
    var that = this; // Shared variables:

    that.element = el;
    that.el = $(el);
    that.suggestions = [];
    that.badQueries = [];
    that.selectedIndex = -1;
    that.currentValue = that.element.value;
    that.timeoutId = null;
    that.cachedResponse = {};
    that.onChangeTimeout = null;
    that.onChange = null;
    that.isLocal = false;
    that.suggestionsContainer = null;
    that.noSuggestionsContainer = null;
    that.options = $.extend(true, {}, Autocomplete.defaults, options);
    that.classes = {
      selected: 'autocomplete-selected',
      suggestion: 'autocomplete-suggestion'
    };
    that.hint = null;
    that.hintValue = '';
    that.selection = null; // Initialize and set options:

    that.initialize();
    that.setOptions(options);
  }

  Autocomplete.utils = utils;
  $.Autocomplete = Autocomplete;
  Autocomplete.defaults = {
    ajaxSettings: {},
    autoSelectFirst: false,
    appendTo: 'body',
    serviceUrl: null,
    lookup: null,
    onSelect: null,
    onHint: null,
    width: 'auto',
    minChars: 1,
    maxHeight: 300,
    deferRequestBy: 0,
    params: {},
    formatResult: _formatResult,
    formatGroup: _formatGroup,
    delimiter: null,
    zIndex: 9999,
    type: 'GET',
    noCache: false,
    onSearchStart: noop,
    onSearchComplete: noop,
    onSearchError: noop,
    preserveInput: false,
    containerClass: 'autocomplete-suggestions',
    tabDisabled: false,
    dataType: 'text',
    currentRequest: null,
    triggerSelectOnValidInput: true,
    preventBadQueries: true,
    lookupFilter: _lookupFilter,
    paramName: 'query',
    transformResult: _transformResult,
    showNoSuggestionNotice: false,
    noSuggestionNotice: 'No results',
    orientation: 'bottom',
    forceFixPosition: false
  };

  function _lookupFilter(suggestion, originalQuery, queryLowerCase) {
    return suggestion.value.toLowerCase().indexOf(queryLowerCase) !== -1;
  }

  ;

  function _transformResult(response) {
    return typeof response === 'string' ? $.parseJSON(response) : response;
  }

  ;

  function _formatResult(suggestion, currentValue) {
    // Do not replace anything if the current value is empty
    if (!currentValue) {
      return suggestion.value;
    }

    var pattern = '(' + utils.escapeRegExChars(currentValue) + ')';
    return suggestion.value.replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/&lt;(\/?strong)&gt;/g, '<$1>');
  }

  ;

  function _formatGroup(suggestion, category) {
    return '<div class="autocomplete-group">' + category + '</div>';
  }

  ;
  Autocomplete.prototype = {
    initialize: function initialize() {
      var that = this,
          suggestionSelector = '.' + that.classes.suggestion,
          selected = that.classes.selected,
          options = that.options,
          container;
      that.element.setAttribute('autocomplete', 'off'); // html() deals with many types: htmlString or Element or Array or jQuery

      that.noSuggestionsContainer = $('<div class="autocomplete-no-suggestion"></div>').html(this.options.noSuggestionNotice).get(0);
      that.suggestionsContainer = Autocomplete.utils.createNode(options.containerClass);
      container = $(that.suggestionsContainer);
      container.appendTo(options.appendTo || 'body'); // Only set width if it was provided:

      if (options.width !== 'auto') {
        container.css('width', options.width);
      } // Listen for mouse over event on suggestions list:


      container.on('mouseover.autocomplete', suggestionSelector, function () {
        that.activate($(this).data('index'));
      }); // Deselect active element when mouse leaves suggestions container:

      container.on('mouseout.autocomplete', function () {
        that.selectedIndex = -1;
        container.children('.' + selected).removeClass(selected);
      }); // Listen for click event on suggestions list:

      container.on('click.autocomplete', suggestionSelector, function () {
        that.select($(this).data('index'));
      });
      container.on('click.autocomplete', function () {
        clearTimeout(that.blurTimeoutId);
      });

      that.fixPositionCapture = function () {
        if (that.visible) {
          that.fixPosition();
        }
      };

      $(window).on('resize.autocomplete', that.fixPositionCapture);
      that.el.on('keydown.autocomplete', function (e) {
        that.onKeyPress(e);
      });
      that.el.on('keyup.autocomplete', function (e) {
        that.onKeyUp(e);
      });
      that.el.on('blur.autocomplete', function () {
        that.onBlur();
      });
      that.el.on('focus.autocomplete', function () {
        that.onFocus();
      });
      that.el.on('change.autocomplete', function (e) {
        that.onKeyUp(e);
      });
      that.el.on('input.autocomplete', function (e) {
        that.onKeyUp(e);
      });
    },
    onFocus: function onFocus() {
      var that = this;

      if (that.disabled) {
        return;
      }

      that.fixPosition();

      if (that.el.val().length >= that.options.minChars) {
        that.onValueChange();
      }
    },
    onBlur: function onBlur() {
      var that = this,
          options = that.options,
          value = that.el.val(),
          query = that.getQuery(value); // If user clicked on a suggestion, hide() will
      // be canceled, otherwise close suggestions

      that.blurTimeoutId = setTimeout(function () {
        that.hide();

        if (that.selection && that.currentValue !== query) {
          (options.onInvalidateSelection || $.noop).call(that.element);
        }
      }, 200);
    },
    abortAjax: function abortAjax() {
      var that = this;

      if (that.currentRequest) {
        that.currentRequest.abort();
        that.currentRequest = null;
      }
    },
    setOptions: function setOptions(suppliedOptions) {
      var that = this,
          options = $.extend({}, that.options, suppliedOptions);
      that.isLocal = Array.isArray(options.lookup);

      if (that.isLocal) {
        options.lookup = that.verifySuggestionsFormat(options.lookup);
      }

      options.orientation = that.validateOrientation(options.orientation, 'bottom'); // Adjust height, width and z-index:

      $(that.suggestionsContainer).css({
        'max-height': options.maxHeight + 'px',
        'width': options.width + 'px',
        'z-index': options.zIndex
      });
      this.options = options;
    },
    clearCache: function clearCache() {
      this.cachedResponse = {};
      this.badQueries = [];
    },
    clear: function clear() {
      this.clearCache();
      this.currentValue = '';
      this.suggestions = [];
    },
    disable: function disable() {
      var that = this;
      that.disabled = true;
      clearTimeout(that.onChangeTimeout);
      that.abortAjax();
    },
    enable: function enable() {
      this.disabled = false;
    },
    fixPosition: function fixPosition() {
      // Use only when container has already its content
      var that = this,
          $container = $(that.suggestionsContainer),
          containerParent = $container.parent().get(0); // Fix position automatically when appended to body.
      // In other cases force parameter must be given.

      if (containerParent !== document.body && !that.options.forceFixPosition) {
        return;
      } // Choose orientation


      var orientation = that.options.orientation,
          containerHeight = $container.outerHeight(),
          height = that.el.outerHeight(),
          offset = that.el.offset(),
          styles = {
        'top': offset.top,
        'left': offset.left
      };

      if (orientation === 'auto') {
        var viewPortHeight = $(window).height(),
            scrollTop = $(window).scrollTop(),
            topOverflow = -scrollTop + offset.top - containerHeight,
            bottomOverflow = scrollTop + viewPortHeight - (offset.top + height + containerHeight);
        orientation = Math.max(topOverflow, bottomOverflow) === topOverflow ? 'top' : 'bottom';
      }

      if (orientation === 'top') {
        styles.top += -containerHeight;
      } else {
        styles.top += height;
      } // If container is not positioned to body,
      // correct its position using offset parent offset


      if (containerParent !== document.body) {
        var opacity = $container.css('opacity'),
            parentOffsetDiff;

        if (!that.visible) {
          $container.css('opacity', 0).show();
        }

        parentOffsetDiff = $container.offsetParent().offset();
        styles.top -= parentOffsetDiff.top;
        styles.top += containerParent.scrollTop;
        styles.left -= parentOffsetDiff.left;

        if (!that.visible) {
          $container.css('opacity', opacity).hide();
        }
      }

      if (that.options.width === 'auto') {
        styles.width = that.el.outerWidth() + 'px';
      }

      $container.css(styles);
    },
    isCursorAtEnd: function isCursorAtEnd() {
      var that = this,
          valLength = that.el.val().length,
          selectionStart = that.element.selectionStart,
          range;

      if (typeof selectionStart === 'number') {
        return selectionStart === valLength;
      }

      if (document.selection) {
        range = document.selection.createRange();
        range.moveStart('character', -valLength);
        return valLength === range.text.length;
      }

      return true;
    },
    onKeyPress: function onKeyPress(e) {
      var that = this; // If suggestions are hidden and user presses arrow down, display suggestions:

      if (!that.disabled && !that.visible && e.which === keys.DOWN && that.currentValue) {
        that.suggest();
        return;
      }

      if (that.disabled || !that.visible) {
        return;
      }

      switch (e.which) {
        case keys.ESC:
          that.el.val(that.currentValue);
          that.hide();
          break;

        case keys.RIGHT:
          if (that.hint && that.options.onHint && that.isCursorAtEnd()) {
            that.selectHint();
            break;
          }

          return;

        case keys.TAB:
          if (that.hint && that.options.onHint) {
            that.selectHint();
            return;
          }

          if (that.selectedIndex === -1) {
            that.hide();
            return;
          }

          that.select(that.selectedIndex);

          if (that.options.tabDisabled === false) {
            return;
          }

          break;

        case keys.RETURN:
          if (that.selectedIndex === -1) {
            that.hide();
            return;
          }

          that.select(that.selectedIndex);
          break;

        case keys.UP:
          that.moveUp();
          break;

        case keys.DOWN:
          that.moveDown();
          break;

        default:
          return;
      } // Cancel event if function did not return:


      e.stopImmediatePropagation();
      e.preventDefault();
    },
    onKeyUp: function onKeyUp(e) {
      var that = this;

      if (that.disabled) {
        return;
      }

      switch (e.which) {
        case keys.UP:
        case keys.DOWN:
          return;
      }

      clearTimeout(that.onChangeTimeout);

      if (that.currentValue !== that.el.val()) {
        that.findBestHint();

        if (that.options.deferRequestBy > 0) {
          // Defer lookup in case when value changes very quickly:
          that.onChangeTimeout = setTimeout(function () {
            that.onValueChange();
          }, that.options.deferRequestBy);
        } else {
          that.onValueChange();
        }
      }
    },
    onValueChange: function onValueChange() {
      if (this.ignoreValueChange) {
        this.ignoreValueChange = false;
        return;
      }

      var that = this,
          options = that.options,
          value = that.el.val(),
          query = that.getQuery(value);

      if (that.selection && that.currentValue !== query) {
        that.selection = null;
        (options.onInvalidateSelection || $.noop).call(that.element);
      }

      clearTimeout(that.onChangeTimeout);
      that.currentValue = value;
      that.selectedIndex = -1; // Check existing suggestion for the match before proceeding:

      if (options.triggerSelectOnValidInput && that.isExactMatch(query)) {
        that.select(0);
        return;
      }

      if (query.length < options.minChars) {
        that.hide();
      } else {
        that.getSuggestions(query);
      }
    },
    isExactMatch: function isExactMatch(query) {
      var suggestions = this.suggestions;
      return suggestions.length === 1 && suggestions[0].value.toLowerCase() === query.toLowerCase();
    },
    getQuery: function getQuery(value) {
      var delimiter = this.options.delimiter,
          parts;

      if (!delimiter) {
        return value;
      }

      parts = value.split(delimiter);
      return $.trim(parts[parts.length - 1]);
    },
    getSuggestionsLocal: function getSuggestionsLocal(query) {
      var that = this,
          options = that.options,
          queryLowerCase = query.toLowerCase(),
          filter = options.lookupFilter,
          limit = parseInt(options.lookupLimit, 10),
          data;
      data = {
        suggestions: $.grep(options.lookup, function (suggestion) {
          return filter(suggestion, query, queryLowerCase);
        })
      };

      if (limit && data.suggestions.length > limit) {
        data.suggestions = data.suggestions.slice(0, limit);
      }

      return data;
    },
    getSuggestions: function getSuggestions(q) {
      var response,
          that = this,
          options = that.options,
          serviceUrl = options.serviceUrl,
          params,
          cacheKey,
          ajaxSettings;
      options.params[options.paramName] = q;

      if (options.onSearchStart.call(that.element, options.params) === false) {
        return;
      }

      params = options.ignoreParams ? null : options.params;

      if ($.isFunction(options.lookup)) {
        options.lookup(q, function (data) {
          that.suggestions = data.suggestions;
          that.suggest();
          options.onSearchComplete.call(that.element, q, data.suggestions);
        });
        return;
      }

      if (that.isLocal) {
        response = that.getSuggestionsLocal(q);
      } else {
        if ($.isFunction(serviceUrl)) {
          serviceUrl = serviceUrl.call(that.element, q);
        }

        cacheKey = serviceUrl + '?' + $.param(params || {});
        response = that.cachedResponse[cacheKey];
      }

      if (response && Array.isArray(response.suggestions)) {
        that.suggestions = response.suggestions;
        that.suggest();
        options.onSearchComplete.call(that.element, q, response.suggestions);
      } else if (!that.isBadQuery(q)) {
        that.abortAjax();
        ajaxSettings = {
          url: serviceUrl,
          data: params,
          type: options.type,
          dataType: options.dataType
        };
        $.extend(ajaxSettings, options.ajaxSettings);
        that.currentRequest = $.ajax(ajaxSettings).done(function (data) {
          var result;
          that.currentRequest = null;
          result = options.transformResult(data, q);
          that.processResponse(result, q, cacheKey);
          options.onSearchComplete.call(that.element, q, result.suggestions);
        }).fail(function (jqXHR, textStatus, errorThrown) {
          options.onSearchError.call(that.element, q, jqXHR, textStatus, errorThrown);
        });
      } else {
        options.onSearchComplete.call(that.element, q, []);
      }
    },
    isBadQuery: function isBadQuery(q) {
      if (!this.options.preventBadQueries) {
        return false;
      }

      var badQueries = this.badQueries,
          i = badQueries.length;

      while (i--) {
        if (q.indexOf(badQueries[i]) === 0) {
          return true;
        }
      }

      return false;
    },
    hide: function hide() {
      var that = this,
          container = $(that.suggestionsContainer);

      if ($.isFunction(that.options.onHide) && that.visible) {
        that.options.onHide.call(that.element, container);
      }

      that.visible = false;
      that.selectedIndex = -1;
      clearTimeout(that.onChangeTimeout);
      $(that.suggestionsContainer).hide();
      that.onHint(null);
    },
    suggest: function suggest() {
      if (!this.suggestions.length) {
        if (this.options.showNoSuggestionNotice) {
          this.noSuggestions();
        } else {
          this.hide();
        }

        return;
      }

      var that = this,
          options = that.options,
          groupBy = options.groupBy,
          formatResult = options.formatResult,
          value = that.getQuery(that.currentValue),
          className = that.classes.suggestion,
          classSelected = that.classes.selected,
          container = $(that.suggestionsContainer),
          noSuggestionsContainer = $(that.noSuggestionsContainer),
          beforeRender = options.beforeRender,
          html = '',
          category,
          formatGroup = function formatGroup(suggestion, index) {
        var currentCategory = suggestion.data[groupBy];

        if (category === currentCategory) {
          return '';
        }

        category = currentCategory;
        return options.formatGroup(suggestion, category);
      };

      if (options.triggerSelectOnValidInput && that.isExactMatch(value)) {
        that.select(0);
        return;
      } // Build suggestions inner HTML:


      $.each(that.suggestions, function (i, suggestion) {
        if (groupBy) {
          html += formatGroup(suggestion, value, i);
        }

        html += '<div class="' + className + '" data-index="' + i + '">' + formatResult(suggestion, value, i) + '</div>';
      });
      this.adjustContainerWidth();
      noSuggestionsContainer.detach();
      container.html(html);

      if ($.isFunction(beforeRender)) {
        beforeRender.call(that.element, container, that.suggestions);
      }

      that.fixPosition();
      container.show(); // Select first value by default:

      if (options.autoSelectFirst) {
        that.selectedIndex = 0;
        container.scrollTop(0);
        container.children('.' + className).first().addClass(classSelected);
      }

      that.visible = true;
      that.findBestHint();
    },
    noSuggestions: function noSuggestions() {
      var that = this,
          beforeRender = that.options.beforeRender,
          container = $(that.suggestionsContainer),
          noSuggestionsContainer = $(that.noSuggestionsContainer);
      this.adjustContainerWidth(); // Some explicit steps. Be careful here as it easy to get
      // noSuggestionsContainer removed from DOM if not detached properly.

      noSuggestionsContainer.detach(); // clean suggestions if any

      container.empty();
      container.append(noSuggestionsContainer);

      if ($.isFunction(beforeRender)) {
        beforeRender.call(that.element, container, that.suggestions);
      }

      that.fixPosition();
      container.show();
      that.visible = true;
    },
    adjustContainerWidth: function adjustContainerWidth() {
      var that = this,
          options = that.options,
          width,
          container = $(that.suggestionsContainer); // If width is auto, adjust width before displaying suggestions,
      // because if instance was created before input had width, it will be zero.
      // Also it adjusts if input width has changed.

      if (options.width === 'auto') {
        width = that.el.outerWidth();
        container.css('width', width > 0 ? width : 300);
      } else if (options.width === 'flex') {
        // Trust the source! Unset the width property so it will be the max length
        // the containing elements.
        container.css('width', '');
      }
    },
    findBestHint: function findBestHint() {
      var that = this,
          value = that.el.val().toLowerCase(),
          bestMatch = null;

      if (!value) {
        return;
      }

      $.each(that.suggestions, function (i, suggestion) {
        var foundMatch = suggestion.value.toLowerCase().indexOf(value) === 0;

        if (foundMatch) {
          bestMatch = suggestion;
        }

        return !foundMatch;
      });
      that.onHint(bestMatch);
    },
    onHint: function onHint(suggestion) {
      var that = this,
          onHintCallback = that.options.onHint,
          hintValue = '';

      if (suggestion) {
        hintValue = that.currentValue + suggestion.value.substr(that.currentValue.length);
      }

      if (that.hintValue !== hintValue) {
        that.hintValue = hintValue;
        that.hint = suggestion;

        if ($.isFunction(onHintCallback)) {
          onHintCallback.call(that.element, hintValue);
        }
      }
    },
    verifySuggestionsFormat: function verifySuggestionsFormat(suggestions) {
      // If suggestions is string array, convert them to supported format:
      if (suggestions.length && typeof suggestions[0] === 'string') {
        return $.map(suggestions, function (value) {
          return {
            value: value,
            data: null
          };
        });
      }

      return suggestions;
    },
    validateOrientation: function validateOrientation(orientation, fallback) {
      orientation = $.trim(orientation || '').toLowerCase();

      if ($.inArray(orientation, ['auto', 'bottom', 'top']) === -1) {
        orientation = fallback;
      }

      return orientation;
    },
    processResponse: function processResponse(result, originalQuery, cacheKey) {
      var that = this,
          options = that.options;
      result.suggestions = that.verifySuggestionsFormat(result.suggestions); // Cache results if cache is not disabled:

      if (!options.noCache) {
        that.cachedResponse[cacheKey] = result;

        if (options.preventBadQueries && !result.suggestions.length) {
          that.badQueries.push(originalQuery);
        }
      } // Return if originalQuery is not matching current query:


      if (originalQuery !== that.getQuery(that.currentValue)) {
        return;
      }

      that.suggestions = result.suggestions;
      that.suggest();
    },
    activate: function activate(index) {
      var that = this,
          activeItem,
          selected = that.classes.selected,
          container = $(that.suggestionsContainer),
          children = container.find('.' + that.classes.suggestion);
      container.find('.' + selected).removeClass(selected);
      that.selectedIndex = index;

      if (that.selectedIndex !== -1 && children.length > that.selectedIndex) {
        activeItem = children.get(that.selectedIndex);
        $(activeItem).addClass(selected);
        return activeItem;
      }

      return null;
    },
    selectHint: function selectHint() {
      var that = this,
          i = $.inArray(that.hint, that.suggestions);
      that.select(i);
    },
    select: function select(i) {
      var that = this;
      that.hide();
      that.onSelect(i);
    },
    moveUp: function moveUp() {
      var that = this;

      if (that.selectedIndex === -1) {
        return;
      }

      if (that.selectedIndex === 0) {
        $(that.suggestionsContainer).children('.' + that.classes.suggestion).first().removeClass(that.classes.selected);
        that.selectedIndex = -1;
        that.ignoreValueChange = false;
        that.el.val(that.currentValue);
        that.findBestHint();
        return;
      }

      that.adjustScroll(that.selectedIndex - 1);
    },
    moveDown: function moveDown() {
      var that = this;

      if (that.selectedIndex === that.suggestions.length - 1) {
        return;
      }

      that.adjustScroll(that.selectedIndex + 1);
    },
    adjustScroll: function adjustScroll(index) {
      var that = this,
          activeItem = that.activate(index);

      if (!activeItem) {
        return;
      }

      var offsetTop,
          upperBound,
          lowerBound,
          heightDelta = $(activeItem).outerHeight();
      offsetTop = activeItem.offsetTop;
      upperBound = $(that.suggestionsContainer).scrollTop();
      lowerBound = upperBound + that.options.maxHeight - heightDelta;

      if (offsetTop < upperBound) {
        $(that.suggestionsContainer).scrollTop(offsetTop);
      } else if (offsetTop > lowerBound) {
        $(that.suggestionsContainer).scrollTop(offsetTop - that.options.maxHeight + heightDelta);
      }

      if (!that.options.preserveInput) {
        // During onBlur event, browser will trigger "change" event,
        // because value has changed, to avoid side effect ignore,
        // that event, so that correct suggestion can be selected
        // when clicking on suggestion with a mouse
        that.ignoreValueChange = true;
        that.el.val(that.getValue(that.suggestions[index].value));
      }

      that.onHint(null);
    },
    onSelect: function onSelect(index) {
      var that = this,
          onSelectCallback = that.options.onSelect,
          suggestion = that.suggestions[index];
      that.currentValue = that.getValue(suggestion.value);

      if (that.currentValue !== that.el.val() && !that.options.preserveInput) {
        that.el.val(that.currentValue);
      }

      that.onHint(null);
      that.suggestions = [];
      that.selection = suggestion;

      if ($.isFunction(onSelectCallback)) {
        onSelectCallback.call(that.element, suggestion);
      }
    },
    getValue: function getValue(value) {
      var that = this,
          delimiter = that.options.delimiter,
          currentValue,
          parts;

      if (!delimiter) {
        return value;
      }

      currentValue = that.currentValue;
      parts = currentValue.split(delimiter);

      if (parts.length === 1) {
        return value;
      }

      return currentValue.substr(0, currentValue.length - parts[parts.length - 1].length) + value;
    },
    dispose: function dispose() {
      var that = this;
      that.el.off('.autocomplete').removeData('autocomplete');
      $(window).off('resize.autocomplete', that.fixPositionCapture);
      $(that.suggestionsContainer).remove();
    }
  }; // Create chainable jQuery plugin:

  $.fn.devbridgeAutocomplete = function (options, args) {
    var dataKey = 'autocomplete'; // If function invoked without argument return
    // instance of the first matched element:

    if (!arguments.length) {
      return this.first().data(dataKey);
    }

    return this.each(function () {
      var inputElement = $(this),
          instance = inputElement.data(dataKey);

      if (typeof options === 'string') {
        if (instance && typeof instance[options] === 'function') {
          instance[options](args);
        }
      } else {
        // If instance already exists, destroy it:
        if (instance && instance.dispose) {
          instance.dispose();
        }

        instance = new Autocomplete(this, options);
        inputElement.data(dataKey, instance);
      }
    });
  }; // Don't overwrite if it already exists


  if (!$.fn.autocomplete) {
    $.fn.autocomplete = $.fn.devbridgeAutocomplete;
  }
});

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// general.bundle.js